// Notification.js
import React, { useEffect } from 'react';

export default function Notification({ message, onClose }) {
    useEffect(() => {
      const timer = setTimeout(() => {
        onClose();
      }, 3000); // tự tắt sau 3s
      return () => clearTimeout(timer);
    }, [onClose]);
  
    return (
      <div className="fixed top-4 left-4 bg-blue-600 text-white px-4 py-2 rounded shadow-lg animate-slide-in z-50">
        {message}
      </div>
    );
  }
  